'use client';

import type {FC, PropsWithChildren} from 'react';
import {useState} from 'react';

import type {NavbarContainerProps} from './NavbarContainer';
import NavbarContainer from './NavbarContainer';
import type {NavbarContextValue} from './useNavbar';
import {NavbarProvider} from './useNavbar';

type Props = PropsWithChildren & NavbarContextValue & NavbarContainerProps;

/**
 * Navbar provides context, state to its sub-components.
 * It also renders the layout of the navbar.
 *
 */
const Navbar: FC<Props> = ({children, variant, ...props}) => {
  const [state] = useState({variant: variant ?? `accent`});
  return (
    <NavbarProvider value={state}>
      <NavbarContainer {...props}>{children}</NavbarContainer>
    </NavbarProvider>
  );
};

export default Navbar;
export type {Props as NavBarProps};
